var React = require('react');

function WarningCircle (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("circle",{"id":"path-1","cx":"12","cy":"12","r":"12"})),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"warning_icon"},[React.createElement("g",{"id":"Oval-5","fill":"#FFFFFF","fillRule":"nonzero","key":0},React.createElement("circle",{"id":"path-1","cx":"12","cy":"12","r":"12"})),React.createElement("g",{"id":"!-Clipped","key":1},[React.createElement("mask",{"id":"mask-2","fill":"white","key":0},React.createElement("use",{"xlinkHref":"#path-1"})),React.createElement("g",{"id":"path-1","key":1}),React.createElement("path",{"d":"M12.8059701,15 L11.2686567,15 L11,6 L13,6 L12.8059701,15 Z M11,18 L11,16 L13,16 L13,18 L11,18 Z","id":"!","fill":"#8B8B8B","fillRule":"nonzero","mask":"url(#mask-2)","key":2})])]))]);
}

WarningCircle.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"};

module.exports = WarningCircle;

WarningCircle.default = WarningCircle;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/common/svg/icons/warning-circle.svg
// module id = 1520
// module chunks = 0